import styled from "@emotion/styled";
import { ExButton } from "@energyx-dev/energyx-ui";
import { useState } from "react";

const terms = [
  {
    imgUrl: "https://s3.ap-northeast-2.amazonaws.com/energyx.file/assets/logos/energyx-logo.svg",
    path: process.env.ENERGYX_URL,
  },
  {
    imgUrl: "https://s3.ap-northeast-2.amazonaws.com/xtudy.file/logo/tomarch_logo_without_desc.png",
    path: process.env.TOMARCH_URL,
  },
  {
    imgUrl: "https://s3.ap-northeast-2.amazonaws.com/xtudy.file/logo/design_whos_logo.png",
    path: process.env.DESIGN_WHOS_URL,
  },
];

export const MoveTerms = () => {
  const [isShow, setIsShow] = useState(false);

  return (
    <Wrap isShow={isShow}>
      <ShowToggleController onClick={() => setIsShow(!isShow)}>
        전체 서비스 보기
        {isShow ? (
          <img src={require("../../../asset/icon/top_arrow.png")} alt="arrow" />
        ) : (
          <img src={require("../../../asset/icon/chevron.png")} alt="arrow" />
        )}
      </ShowToggleController>
      <ItemWrap>
        {terms.map((term, i) => (
          <Item key={i} isLine={i !== terms.length - 1}>
            <img src={term.imgUrl} alt="로고" />
            <ExButton
              size="tiny"
              label="바로가기"
              variant="contained"
              backgroundColor="#5E67BA"
              onClick={() => (window.location.href = term.path!)}
            />
          </Item>
        ))}
      </ItemWrap>
    </Wrap>
  );
};

const Wrap = styled.div<{ isShow: boolean }>`
  height: ${({ isShow }) => (isShow ? "241px" : "60px")};
  overflow: hidden;
  box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.07);
  transition: 0.3s;
  width: 100%;
`;

const ItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  border-top: 1px solid #adadad;
`;

const ShowToggleController = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  padding: 0px 16px;
  align-items: center;
  justify-content: space-between;

  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: -0.25px;
`;

const Item = styled.div<{ isLine: boolean }>`
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ isLine }) => isLine && "border-bottom: 1px solid #D9D9D9"};

  > img {
    height: 14px;
  }

  &:nth-child(2) {
    > img {
      height: 25px;
    }
  }
`;
